import cx from 'classnames';
import { ElementType, ReactNode } from 'react';

import { IconDot } from '../icons/Dot';
import { Typography } from '../typography/Typography';

import style from './ListItem.module.css';

export type OrderedListItemProps = {
    ordered: true;
    outlined?: boolean;
    index?: number;
    BulletIcon?: never;
};

export type UnorderedListItemProps = {
    ordered?: false;
    outlined?: never;
    index?: never;
    BulletIcon?: ElementType;
};

type ListItemProps = {
    children: ReactNode;
    className?: string;
    classes?: {
        marker?: string;
        content?: string;
    };
} & (OrderedListItemProps | UnorderedListItemProps);

export function ListItem({
    children,
    className,
    ordered,
    outlined,
    BulletIcon,
    classes,
    index = 0,
}: ListItemProps) {
    if (BulletIcon && ordered) {
        console.warn('ListItem: You should not provide BulletIcon on ordered list items.');
    }

    const Icon = BulletIcon ?? IconDot;
    return (
        <li
            className={cx(style.item, className, {
                [style.ordered]: ordered,
                [style.outlined]: outlined,
            })}
        >
            <div className={cx(style.marker, classes?.marker)}>
                {ordered ? (
                    <Typography scale="primary-body-bold" as="span">
                        {`${index + 1}${outlined ? '' : '.'}`}
                    </Typography>
                ) : (
                    <Icon className={style.icon} />
                )}
            </div>
            <div className={cx(style.content, classes?.content)}>
                {['string', 'number'].includes(typeof children) ? (
                    <Typography scale="primary-body-regular">{children}</Typography>
                ) : (
                    // That div is needed to make the content not a child of a flex item
                    <div>{children}</div>
                )}
            </div>
        </li>
    );
}
